import { render } from "./CompetencesTable.vue?vue&type=template&id=b2a70118&scoped=true"
import script from "./CompetencesTable.vue?vue&type=script&lang=js"
export * from "./CompetencesTable.vue?vue&type=script&lang=js"

import "./CompetencesTable.vue?vue&type=style&index=0&id=b2a70118&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a70118"]])

export default __exports__